import Editor, {
  BtnBold,
  BtnBulletList,
  BtnItalic,
  BtnLink,
  BtnNumberedList,
  Toolbar,
} from 'react-simple-wysiwyg';

interface SignatureEditorProps {
  value?: string;
  onChange: (html: string) => void;
  disabled?: boolean;
  allowRawHtmlPaste?: boolean;
}

export const SignatureEditor: React.FC<SignatureEditorProps> = ({
  value = '',
  onChange,
  disabled = false,
}) => {
  const handleChange: React.ComponentProps<typeof Editor>['onChange'] = e => {
    onChange(e.target.value);
  };

  return (
    <div className="signature-editor">
      <Editor
        value={value}
        onChange={handleChange}
        disabled={disabled}
        placeholder="Saisissez votre signature..."
        containerProps={{
          style: {
            minHeight: '120px',
            border: '1px solid #d1d5db',
            borderRadius: '0.75rem',
          },
        }}
      >
        <Toolbar>
          <BtnBold />
          <BtnItalic />
          <BtnLink />
          <BtnBulletList />
          <BtnNumberedList />
        </Toolbar>
      </Editor>
    </div>
  );
};
